import React from "react"
import Icon from "../../../../components/Icon/Icon"
import {Modal} from "../../../../components/Modals/Modal"
import {Button} from "../../../../components/Button/Button"
import {formatCurrency, formatDisplayDate} from "./utils"

interface ConfirmationDialogProps {
	limitLabel: {category: string; name: string}
	close: () => void
	onConfirm: () => void
	onBack: () => void
	isReverting: boolean
	toAmount: number
	endDate?: string
	currentLimit: number
	isLoading: boolean
	error?: string
}

export function ConfirmationDialog({
	limitLabel,
	close,
	onConfirm,
	onBack,
	isReverting,
	toAmount,
	endDate,
	currentLimit,
	isLoading,
	error,
}: ConfirmationDialogProps) {
	return (
		<Modal
			close={close}
			classname="limit-override-modal limit-override-modal--confirmation"
			enableClickAway={false}
			blockBodyScroll
		>
			<h3 className="modal-card-title">Are You Sure You Want To Save Change?</h3>
			<p className="limit-override-confirmation-subtitle">When saving the changes will apply on the account limit.</p>

			<div className="limit-override-confirmation-section">
				<div className="limit-override-confirmation-title">
					{limitLabel.category} {limitLabel.name}
				</div>
				<div className="limit-override-confirmation">
					<div className="limit-override-confirmation-box limit-override-confirmation-box--default">
						<div className="limit-override-confirmation-box-column">
							<span className="limit-override-confirmation-label">Current Limit</span>
							<div className="limit-override-confirmation-amount limit-override-confirmation-amount--strikethrough">
								{formatCurrency(currentLimit)}
							</div>
						</div>
					</div>

					<div className="limit-override-confirmation-arrow">→</div>

					<div className="limit-override-confirmation-box limit-override-confirmation-box--new">
						<div className="limit-override-confirmation-box-column">
							<span className="limit-override-confirmation-label">
								{isReverting ? "Deposit Product Limit (default)" : "New Limit"}
							</span>
							<span className="limit-override-confirmation-amount">{formatCurrency(toAmount)}</span>
						</div>
						{endDate && (
							<div className="limit-override-confirmation-box-column">
								<span className="limit-override-confirmation-label">End date</span>
								<span className="limit-override-confirmation-date">
									<Icon icon="calendar-2--interface-essential" size={16} />
									{formatDisplayDate(endDate)}
								</span>
							</div>
						)}
					</div>
				</div>
			</div>

			{error && <div className="limit-override-error">{error}</div>}

			<footer className="limit-override-footer">
				<Button type="button" className="button" variant="flat" onClick={onBack} disabled={isLoading}>
					Cancel
				</Button>
				<Button type="button" onClick={onConfirm} disabled={isLoading} loading={isLoading}>
					Save
				</Button>
			</footer>
		</Modal>
	)
}
